"use strict";

export default ($axios, store) => ({
  list() {
    return $axios.$get("/daisuke/application");
  },
  get(id) {
    return $axios.$get(`/daisuke/application/${id}`);
  },
  create(app) {
    return $axios.post("/daisuke/application", app, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  update(id, app) {
    return $axios.put(`/daisuke/application/${id}`, app);
  },
  remove(id) {
    return $axios.delete(`/daisuke/application/${id}`);
  },
});
